import axios from "axios";
import * as XLSX from "xlsx";
import "./expenseOverview.css";
import Select from 'react-select';
import Modal from "react-modal";
import { DatePicker } from "rsuite";
import CalendarIcon from "../../components/ui/CalendarIcon";
import subDays from "date-fns/subDays";
import moment from "moment-timezone";
import { DateRangePicker } from "rsuite";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import isEqual from 'lodash/isEqual';
import { useSelector, useDispatch } from 'react-redux';
import ExpenseOverviewTotal from "./expenseOverviewTotal";
import ExpenseOverviewGraph from "./expenseOverviewGraph";
import ExpenseOverviewPieChart from "./expenseOverviewPiechart";
import ExpenseTable from "./expenseTable";
import React, { useState, useRef, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { useQueryClient } from 'react-query';
import userTypeConsts from "../../constants/userTypeConsts";
import DownloadImage from "../../images/icons/download-icon.svg";
import PlusIcon from "../../images/icons/plus-icon.svg";
import Plus from "../../images/icons/plus-black.svg";
import Close from "../../images/icons/black-close.svg";
import Tick from "../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import TruncateFilterFieldView from "../../components/helpers/truncateFilterFieldView.js";
import Currencies from "../../constants/currenciesList.js";
import { useGetClients, useGetProjects, useGetDepartments, useGetTeams, useGetActiveTeams, useGetExpenseClients, useGetExpenceDepartments } from "../../components/TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import { setExpTeam, setExpClient, setExpProject, setExpDepartment, setFilterExpCategory, setFilterExpCurrency, setExpenseData, setFilterExpStatus, setAllExpenseFilters } from "../../features/expenseData/expenseDataSlice.js";
import { useFetchExpCategory } from "../../components/AppSettings/expenseCategoryApi.jsx";
import { useGetExpenseData, useExpenseId, useFetchExpenseCurrency } from "../../features/expenseData/useExpenseData.jsx";
import { setNotification } from "../../features/notification/notificationSlice.js";
import { logout, reset } from "../../features/auth/authSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import { setDashboardCurrencyRx, setDashboardCurrencySum } from "../../features/invoice/invoiceSlice";
import Calendar from "../../helpers/dateComponents/Calendar";
import { setForex } from "../../features/forex/forexSlice.js";
import { useFetchDashboardCurrency } from "../../components/Dashboard/DashboardCurrencyApi";
import getCurrencyByCode from 'currency-codes';
import { motion } from 'framer-motion';
import { useWXCompanies } from "../../components/User/UserDetails/UserProfile/useUserView.jsx";
import { ExpenseFilters } from "./components";
import { useExpenseForm, useExpenseModals } from "./hooks";
import { handleApiError, handleError, showErrorToast, withErrorHandling, EXPENSE_ERROR_CODES } from "./utils/errorHandling";
import { withRetry, handleErrorWithRecovery } from "./utils/errorRecovery";
import ExpenseErrorBoundary from "./utils/ErrorBoundary";

const ranges = [
  {
    label: "today",
    value: new Date(), // Use a single date instead of an array
  },
  {
    label: "yesterday",
    value: subDays(new Date(), 1),
  },
];

const expenseStatusList = [
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "pending", label: "Pending" },
];

const ExpenseOverviewContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dates, setDates] = useState(new Date());
  const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const startOfYear = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
  const endOfYear = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999);
  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  // Use custom hooks for state management
  const expenseForm = useExpenseForm();
  const expenseModals = useExpenseModals();

  // Extract form state and setters from hook
  const {
    formState,
    setDescription,
    setExpenseDate,
    setCategory,
    setCurrency,
    setSubTotal,
    setTax,
    setAmount,
    setIsBillable,
    setUser,
    setClient,
    setProject,
    setCompany,
    setNote,
    setFileAttachment,
    setFileAttachmentName,
    setCurrencySearchTerm,
    setUserSearchTerm,
    setClientSearchTerm,
    setProjectSearchTerm,
    setCompanySearchTerm,
    setCurrencyDropdownOpen,
    setCategoryDropdownOpen,
    setUserDropdownOpen,
    setClientDropdownOpen,
    setProjectDropdownOpen,
    setCompanyDropdownOpen,
    setDescriptionValid,
    setDateValid,
    setCategoryValid,
    setCurrencyValid,
    setSubTotalValid,
    setTaxValid,
    setUserValid,
    setClientValid,
    setCompanyValid,
    descriptionRef,
    dateRef,
    categoryRef,
    currencyRef,
    subTotalRef,
    taxRef,
    userRef,
    clientRef,
    companyRef,
    validateForm: validateExpenseFormField,
    resetForm: resetExpenseForm,
  } = expenseForm;

  // Extract modal state and handlers from hook
  const {
    isCreateModalOpen,
    setIsCreateModalOpen,
    openCreateModal,
    closeCreateModal,
  } = expenseModals;

  // Other state variables
  const [showCalendar, setShowCalendar] = useState(false);
  const [showModalCalendar, setShowModalCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([startOfYear, endOfToday]);
  const [perPage, setPerPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const expenseData = useSelector((state) => state.expenseData);
  const componentRef = useRef();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [allCurrency, setAllCurrency] = useState(false);
  const dashboradCurrency = useSelector((state) => state.invoice.dashboardCurrency);
  const dashboardCurrencySum = useSelector((state) => state.invoice.dashboardCurrencySum);
  const [selectedCurrency, setSelectedCurrency] = useState(dashboradCurrency);

  // Map form state to old variable names for backward compatibility
  const expDescription = formState.description;
  const expenseDate = formState.expenseDate;
  const expCategory = formState.category;
  const expCurrency = formState.currency;
  const expSubTotal = formState.subTotal;
  const expTax = formState.tax;
  const expAmount = formState.amount;
  const expIsBillable = formState.isBillable;
  const expenseUser = formState.user;
  const expenseClient = formState.client;
  const expenseProject = formState.project;
  const expenseCompany = formState.company;
  const expNote = formState.note;
  const expFileAttchFiles = formState.fileAttachment;
  const expFileAttchFileName = formState.fileAttachmentName;
  const expCurrencySearchTerm = formState.currencySearchTerm;
  const userSearchTerm = formState.userSearchTerm;
  const expClientSearchTerm = formState.clientSearchTerm;
  const expProjectSearchTerm = formState.projectSearchTerm;
  const expCompanySearchTerm = formState.companySearchTerm;
  const expCurrencyDropdownOpen = formState.currencyDropdownOpen;
  const expenseCategoryDropdownOpen = formState.categoryDropdownOpen;
  const expenseUserDropdownOpen = formState.userDropdownOpen;
  const expClientDropdownOpen = formState.clientDropdownOpen;
  const expProjectDropdownOpen = formState.projectDropdownOpen;
  const expCompanyDropdownOpen = formState.companyDropdownOpen;
  const expenseDescriptionIsValid = formState.descriptionIsValid;
  const expenseCurrencyIsValid = formState.currencyIsValid;
  const expSubTotalIsValid = formState.subTotalIsValid;
  const expTaxIsValid = formState.taxIsValid;
  const expenseDateIsValid = formState.dateIsValid;
  const expenseCategoryIsValid = formState.categoryIsValid;
  const expenseUserIsValid = formState.userIsValid;
  const expenseClientIsValid = formState.clientIsValid;
  const expenseCompanyIsValid = formState.companyIsValid;
  const [expCurrencyList, setExpCurrencyList] = useState([]);
  const [selectAllTeam, setSelectAllTeam] = useState(true);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [isTeamDropdownOpen, setIsTeamDropdownOpen] = useState(false);
  const [isTeamModalDropdownOpen, setIsTeamModalDropdownOpen] = useState(false);
  const [userDropdownSearchTerm, setUserDropdownSearchTerm] = useState('');
  const [selectAllClient, setSelectAllClient] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [isClientModalDropdownOpen, setIsClientModalDropdownOpen] = useState(false);
  const [clientDropdownSearchTerm, setClientDropdownSearchTerm] = useState('');
  const [selectAllProject, setSelectAllProject] = useState(true);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
  const [isProjectModalDropdownOpen, setIsProjectModalDropdownOpen] = useState(false);
  const [projectFilterSearchTerm, setProjectFilterSearchTerm] = useState('');
  const [selectAllDept, setSelectAllDept] = useState(true);
  const [selectedDepts, setSelectedDepts] = useState([]);
  const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
  const [departmentDropdownSearchTerm, setDepartmentDropdownSearchTerm] = useState('');
  const [isDeptModalDropdownOpen, setIsDeptModalDropdownOpen] = useState(false);
  const [selectAllExpCategory, setSelectAllExpCategory] = useState(true);
  const [selectedExpCategories, setSelectedExpCategories] = useState([]);
  const [isExpCategoryDropdownOpen, setIsExpCategoryDropdownOpen] = useState(false);
  const [isExpCategoryModalDropdownOpen, setIsExpCategoryModalDropdownOpen] = useState(false);
  const [categoryDropdownSearchTerm, setCategoryDropdownSearchTerm] = useState('');
  const [selectAllExpCurrencyFilter, setSelectAllExpCurrencyFilter] = useState(true);
  const [selectedExpCurrenciesFilter, setSelectedExpCurrenciesFilter] = useState([]);
  const [isExpCurrencyFilterDropdownOpen, setIsExpCurrencyFilterDropdownOpen] = useState(false);
  const [isExpCurrencyFilterModalDropdownOpen, setIsExpCurrencyFilterModalDropdownOpen] = useState(false);
  const [expCurrencyDropdownSearchTerm, setExpCurrencyDropdownSearchTerm] = useState('');
  const [selectedExpStatusFilter, setSelectedExpStatusFilter] = useState([]);
  const [isExpStatusFilterDropdownOpen, setIsExpStatusFilterDropdownOpen] = useState(false);
  const [expStatusDropdownSearchTerm, setExpStatusDropdownSearchTerm] = useState("");
  const [selectAllExpStatusFilter, setSelectAllExpStatusFilter] = useState(false);
  const teamDropdownRef = useRef(null);
  const teamModalDropdownRef = useRef(null);
  const clientDropdownRef = useRef(null);
  const clientModalDropdownRef = useRef(null);
  const projectDropdownRef = useRef(null);
  const projectModalDropdownRef = useRef(null);
  const deptDropdownRef = useRef(null);
  const deptModalDropdownRef = useRef(null);
  const expCategoryDropdownRef = useRef(null);
  const expCategoryModalDropdownRef = useRef(null);
  const expCurrencyFilterDropdownRef = useRef(null);
  const expStatusFilterDropdownRef = useRef(null);
  const expCurrencyFilterModalDropdownRef = useRef(null);
  const expenseDateRef = useRef(null);
  const expenseDescriptionRef = useRef(null);
  const expenseCategoryRef = useRef(null);
  const expenseCurrencyRef = useRef(null);
  const expSubTotalRef = useRef(null);
  const expTaxRef = useRef(null);
  const expCurrencyDropdownRef = useRef(null);
  const expenseUserRef = useRef(null);
  const expenseUserSelectDropdownRef = useRef(null);
  const expenseClientRef = useRef(null);
  const expenseClientDropdownRef = useRef(null);
  const expenseProjectRef = useRef(null);
  const expenseProjectDropdownRef = useRef(null);
  const expenseCompanyRef = useRef(null);
  const expenseCompanyDropdownRef = useRef(null);
  const expenseCategoryDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const calendarRef = useRef(null);
  const calendarModalRef = useRef(null);
  const calendarModalPortalRef = useRef(null);
  const expFileAttchRef = useRef(null);
  const prevTeamsRef = useRef([]);
  const prevClientsRef = useRef([]);
  const prevProjectsRef = useRef([]);
  const prevDeptsRef = useRef([]);
  const prevCategoriesRef = useRef([]);
  const prevStatusListRef = useRef([]);
  const currencyListInitializedRef = useRef(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { appSettings } = useSelector((state) => state.appSettings);
  const token = useSelector(
    (state) => state.auth.token
  )

  const { data: teams = [], isLoading: teamLoading, isError: teamError } = useGetTeams(token);
  const { data: activeTeams = [], isLoading: activeTeamLoading, isError: activeTeamError } = useGetActiveTeams(token);
  const { data: clients = [], isLoading: clientLoading, isError: clientError } = useGetExpenseClients(token);
  const { data: projects = [], isLoading: projectLoading, isError: projectError } = useGetProjects(token);
  const { data: wXCompany = [], isLoading: WXCompaniesLoading, isError: WXCompaniesError } = useWXCompanies();
  const { data: departments = [], isLoading: departmentLoading, isError: departmentError } = useGetExpenceDepartments();
  const { data: expenseId = [], isLoading: isLoadingExpenseId, refetch: refetchExpenseId } = useExpenseId(token);
  const { data: expenseCurrencies = [], refetch: refetchExpenseCurrencies } = useFetchExpenseCurrency(
    token,
    expenseData,
    dateRange && dateRange[0] || startOfYear,
    dateRange && dateRange[1] || endOfToday
  );
  const { data: expenseCategory = [], isLoading: isLoadingExpCategory } = useFetchExpCategory(token);
  const { data: expenseDatas = [], isLoading: expenseLoading, totalCount: expenseTotalCount, currencyTotals, refetch: refetchExpenseData } = useGetExpenseData(
    token,
    expenseData,
    dateRange && dateRange[0] || startOfYear,
    dateRange && dateRange[1] || endOfToday,
    currentPage,
    perPage,
    allCurrency,
    selectedCurrency,
  );
  const selectAllRef = useRef();

  const filteredExpStatusList = useMemo(() =>
    expenseStatusList.filter(status =>
      status.label.toLowerCase().includes(expStatusDropdownSearchTerm.toLowerCase())
    ),
  [expStatusDropdownSearchTerm]);


  const handleCheckboxTeamChange = (teamId) => {
    const updatedSelection = [...selectedTeams];
    const index = updatedSelection.indexOf(teamId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(teamId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedTeams(updatedSelection);
  };

  const handleSelectAllTeamChange = () => {
    if (!selectAllTeam) {
      setSelectedTeams(teams.map((team) => team._id));
    } else {
      setSelectedTeams([]);
    }
    setSelectAllTeam(!selectAllTeam);
  };

  const filteredDropdownUsers = useMemo(() =>
    teams.filter((user) => {
      const fullName = user.first_name
        ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
        : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
      return fullName.toLowerCase().includes(userDropdownSearchTerm.toLowerCase());
    }),
  [teams, userDropdownSearchTerm]);

  const handleUserDropdownSearchChange = (e) => {
    setUserDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    const handleLoading = async () => {
      await dispatch(setAppLoading(expenseLoading));
    };
    handleLoading();
  }, [expenseLoading]);

  useEffect(() => {
    const timer = setTimeout(() => {
      // When data not loaded yet (both empty), keep selectAll=true so "All" shows instead of "Select"
      const isAllTeamsSelected = teams.length === 0 ? true : selectedTeams.length === teams.length;
      const isAllClientsSelected = clients.length === 0 ? true : selectedClients.length === clients.length;
      const isAllProjectsSelected = projects.length === 0 ? true : selectedProjects.length === projects.length;
      const isAllDeptsSelected = departments.length === 0 ? true : selectedDepts.length === departments.length;
      const isAllCategoriesSelected = expenseCategory.length === 0 ? true : selectedExpCategories.length === expenseCategory.length;
      const isAllCurrenciesSelected = expCurrencyList.length === 0 ? true : selectedExpCurrenciesFilter.length === expCurrencyList.length;
      const isAllStatusSelected = selectedExpStatusFilter.length === expenseStatusList.length;

      setSelectAllTeam(isAllTeamsSelected);
      setSelectAllClient(isAllClientsSelected);
      setSelectAllDept(isAllDeptsSelected);
      setSelectAllExpCategory(isAllCategoriesSelected);
      setSelectAllExpCurrencyFilter(isAllCurrenciesSelected);
      setSelectAllExpStatusFilter(isAllStatusSelected);

      dispatch(setAllExpenseFilters({
        expTeam: isAllTeamsSelected ? null : selectedTeams,
        expClient: isAllClientsSelected ? null : selectedClients,
        expProject: isAllProjectsSelected ? null : selectedProjects,
        expDepartment: isAllDeptsSelected ? null : selectedDepts,
        filterExpCategory: isAllCategoriesSelected ? null : selectedExpCategories,
        filterExpCurrency: isAllCurrenciesSelected ? null : selectedExpCurrenciesFilter,
        filterExpStatus: selectedExpStatusFilter,
      }));
    }, 100);

    return () => clearTimeout(timer);
  }, [selectedTeams, selectedClients, selectedProjects, selectedDepts, selectedExpCategories, selectedExpCurrenciesFilter, selectedExpStatusFilter, teams, clients, projects, departments, expenseCategory, expCurrencyList, dispatch]);


  const toggleTeamDropdown = () => {
    setIsTeamDropdownOpen(!isTeamDropdownOpen);
    setUserDropdownSearchTerm("");
  };

  const toggleTeamModalDropdown = () => {
    setIsTeamModalDropdownOpen(!isTeamModalDropdownOpen);
    setUserDropdownSearchTerm("");
  };

  const handleCheckboxClientChange = (clientId) => {
    const updatedSelection = [...selectedClients];
    const index = updatedSelection.indexOf(clientId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(clientId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedClients(updatedSelection);
  };

  const handleSelectAllClientChange = () => {
    if (!selectAllClient) {
      setSelectedClients(clients.map((client) => client._id));
    } else {
      setSelectedClients([]);
    }
    setSelectAllClient(!selectAllClient);
  };

  const filteredDropdownClients = useMemo(() =>
    clients.filter((client) => {
      const clientName = client.client_name || client.legal_entity_name || '';
      return clientName.toLowerCase().includes(clientDropdownSearchTerm.toLowerCase());
    }),
  [clients, clientDropdownSearchTerm]);

  const handleClientDropdownSearchChange = (e) => {
    setClientDropdownSearchTerm(e.target.value);
  };


  const toggleClientDropdown = () => {
    setIsClientDropdownOpen(!isClientDropdownOpen);
    setClientDropdownSearchTerm("");
  };

  const toggleClientModalDropdown = () => {
    setIsClientModalDropdownOpen(!isClientModalDropdownOpen);
    setClientDropdownSearchTerm("");
  };

  const handleCheckboxProjectChange = (projectId) => {
    const updatedSelection = [...selectedProjects];
    const index = updatedSelection.indexOf(projectId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(projectId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedProjects(updatedSelection);
  };

  const handleSelectAllProjectChange = () => {
    if (!selectAllProject) {
      setSelectedProjects(projects.map((project) => project._id));
    } else {
      setSelectedProjects([]);
    }
    setSelectAllProject(!selectAllProject);
  };


  const toggleProjectDropdown = () => {
    setIsProjectDropdownOpen(!isProjectDropdownOpen);
  };

  const toggleProjectModalDropdown = () => {
    setIsProjectModalDropdownOpen(!isProjectModalDropdownOpen);
  };

  const handleCheckboxDeptChange = (deptId) => {
    const updatedSelection = [...selectedDepts];
    const index = updatedSelection.indexOf(deptId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(deptId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedDepts(updatedSelection);
  };

  const handleSelectAllDeptChange = () => {
    if (!selectAllDept) {
      setSelectedDepts(departments.map((dept) => dept._id));
    } else {
      setSelectedDepts([]);
    }
    setSelectAllDept(!selectAllDept);
  };

  const filteredDropdownDepartments = useMemo(() =>
    departments.filter((department) =>
      department?.user_department?.toLowerCase().includes(departmentDropdownSearchTerm.toLowerCase())
    ),
  [departments, departmentDropdownSearchTerm]);

  const handleDepartmentDropdownSearchChange = (e) => {
    setDepartmentDropdownSearchTerm(e.target.value);
  };


  const toggleDeptDropdown = () => {
    setIsDeptDropdownOpen(!isDeptDropdownOpen);
    setDepartmentDropdownSearchTerm("");
  };

  const toggleDeptModalDropdown = () => {
    setIsDeptModalDropdownOpen(!isDeptModalDropdownOpen);
    setDepartmentDropdownSearchTerm("");
  };

  const handleCheckboxExpCategoryChange = (expCategoryId) => {
    const updatedSelection = [...selectedExpCategories];
    const index = updatedSelection.indexOf(expCategoryId);

    if (index === -1) {
      updatedSelection.push(expCategoryId);
    } else {
      updatedSelection.splice(index, 1);
    }

    setSelectedExpCategories(updatedSelection);
  };

  const handleSelectAllExpCategoryChange = () => {
    if (!selectAllExpCategory) {
      setSelectedExpCategories(expenseCategory.map((expCat) => expCat._id));
    } else {
      setSelectedExpCategories([]);
    }
    setSelectAllExpCategory(!selectAllExpCategory);
  };

  const filteredDropdownExpenseCategory = useMemo(() =>
    expenseCategory.filter((expCat) =>
      expCat?.exp_category_name?.toLowerCase().includes(categoryDropdownSearchTerm.toLowerCase())
    ),
  [expenseCategory, categoryDropdownSearchTerm]);

  const handleCategoryDropdownSearchChange = (e) => {
    setCategoryDropdownSearchTerm(e.target.value);
  };


  const toggleExpCategoryDropdown = () => {
    setIsExpCategoryDropdownOpen(!isExpCategoryDropdownOpen);
    setCategoryDropdownSearchTerm("");
  };

  const toggleExpCategoryModalDropdown = () => {
    setIsExpCategoryModalDropdownOpen(!isExpCategoryModalDropdownOpen);
    setCategoryDropdownSearchTerm("");
  };

  const handleCheckboxExpCurrencyFilterChange = (expCurrencyFilterId) => {
    const updatedSelection = [...selectedExpCurrenciesFilter];
    const index = updatedSelection.indexOf(expCurrencyFilterId);

    if (index === -1) {
      updatedSelection.push(expCurrencyFilterId);
    } else {
      updatedSelection.splice(index, 1);
    }

    setSelectedExpCurrenciesFilter(updatedSelection);
  };

  const handleSelectAllExpCurrencyFilterChange = () => {
    if (!selectAllExpCurrencyFilter) {
      setSelectedExpCurrenciesFilter(expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    } else {
      setSelectedExpCurrenciesFilter([]);
    }
    setSelectAllExpCurrencyFilter(!selectAllExpCurrencyFilter);
  };

  const filteredDropdownExpCurrencyList = useMemo(() =>
    expCurrencyList.filter((expCurrency) =>
      `${expCurrency.currencyCode} (${expCurrency.currencyName})`
        .toLowerCase()
        .includes(expCurrencyDropdownSearchTerm.toLowerCase())
    ),
  [expCurrencyList, expCurrencyDropdownSearchTerm]);

  const handleExpCurrencyDropdownSearchChange = (e) => {
    setExpCurrencyDropdownSearchTerm(e.target.value);
  };


  const toggleExpCurrencyFilterDropdown = () => {
    setIsExpCurrencyFilterDropdownOpen(!isExpCurrencyFilterDropdownOpen);
    setExpCurrencyDropdownSearchTerm("");
  };

  const toggleExpCurrencyFilterModalDropdown = () => {
    setIsExpCurrencyFilterModalDropdownOpen(!isExpCurrencyFilterModalDropdownOpen);
    setExpCurrencyDropdownSearchTerm("");
  };

  const toggleExpStatusFilterDropdown = () => {
    setIsExpStatusFilterDropdownOpen(!isExpStatusFilterDropdownOpen);
  };

  const handleExpStatusDropdownSearchChange = (e) => {
    setExpStatusDropdownSearchTerm(e.target.value);
  };

  const handleSelectAllExpStatusFilterChange = () => {
    if (selectAllExpStatusFilter) {
      setSelectedExpStatusFilter([]);
    } else {
      setSelectedExpStatusFilter(expenseStatusList.map((s) => s.value));
    }
    setSelectAllExpStatusFilter(!selectAllExpStatusFilter);
  };

  const handleCheckboxExpStatusFilterChange = (value) => {
    setSelectedExpStatusFilter((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };


  const handleClickOutsideDropdown = (event) => {
    const isClickInsideShowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);
    const isClickInsideTeamDropdown = teamDropdownRef.current && teamDropdownRef.current.contains(event.target);
    const isClickInsideTeamModalDropdown = teamModalDropdownRef.current && teamModalDropdownRef.current.contains(event.target);
    const isClickInsideClientDropdown = clientDropdownRef.current && clientDropdownRef.current.contains(event.target);
    const isClickInsideClientModalDropdown = clientModalDropdownRef.current && clientModalDropdownRef.current.contains(event.target);
    const isClickInsideProjectDropdown = projectDropdownRef.current && projectDropdownRef.current.contains(event.target);
    const isClickInsideProjectModalDropdown = projectModalDropdownRef.current && projectModalDropdownRef.current.contains(event.target);
    const isClickInsideDeptDropdown = deptDropdownRef.current && deptDropdownRef.current.contains(event.target);
    const isClickInsideDeptModalDropdown = deptModalDropdownRef.current && deptModalDropdownRef.current.contains(event.target);
    const isClickInsideExpCategoryDropdown = expCategoryDropdownRef.current && expCategoryDropdownRef.current.contains(event.target);
    const isClickInsideExpCategoryModalDropdown = expCategoryModalDropdownRef.current && expCategoryModalDropdownRef.current.contains(event.target);
    const isClickInsideExpCurrencyFilterDropdown = expCurrencyFilterDropdownRef.current && expCurrencyFilterDropdownRef.current.contains(event.target);
    const isClickInsideExpCurrencyFilterModalDropdown = expCurrencyFilterModalDropdownRef.current && expCurrencyFilterModalDropdownRef.current.contains(event.target);
    const isClickInsideExpCurrencyDropdown = expCurrencyDropdownRef.current && expCurrencyDropdownRef.current.contains(event.target);
    const isClickInsideExpenseUserDropdown = expenseUserSelectDropdownRef.current && expenseUserSelectDropdownRef.current.contains(event.target);
    const isClickInsideExpClientDropdown = expenseClientDropdownRef.current && expenseClientDropdownRef.current.contains(event.target);
    const isClickInsideExpProjectDropdown = expenseProjectDropdownRef.current && expenseProjectDropdownRef.current.contains(event.target);
    const isClickInsideExpCompanyDropdown = expenseCompanyDropdownRef.current && expenseCompanyDropdownRef.current.contains(event.target);
    const isClickInsideExpenseCategoryDropdown = expenseCategoryDropdownRef.current && expenseCategoryDropdownRef.current.contains(event.target);
    const isClickInsideCalendarDropdown = calendarRef.current && calendarRef.current.contains(event.target);
    const isClickInsideModalCalendarDropdown =
      (calendarModalRef.current && calendarModalRef.current.contains(event.target)) ||
      (calendarModalPortalRef.current && calendarModalPortalRef.current.contains(event.target));

    if (!isClickInsideShowingDropdown) {
      setShowingDropdownOpen(false);
    }
    if (!isClickInsideTeamDropdown) {
      setIsTeamDropdownOpen(false);
    }
    if (!isClickInsideTeamModalDropdown) {
      setIsTeamModalDropdownOpen(false);
    }
    if (!isClickInsideClientDropdown) {
      setIsClientDropdownOpen(false);
    }
    if (!isClickInsideClientModalDropdown) {
      setIsClientModalDropdownOpen(false);
    }
    if (!isClickInsideProjectDropdown) {
      setIsProjectDropdownOpen(false);
    }
    if (!isClickInsideProjectModalDropdown) {
      setIsProjectModalDropdownOpen(false);
    }
    if (!isClickInsideDeptDropdown) {
      setIsDeptDropdownOpen(false);
    }
    if (!isClickInsideDeptModalDropdown) {
      setIsDeptModalDropdownOpen(false);
    }
    if (!isClickInsideExpCategoryDropdown) {
      setIsExpCategoryDropdownOpen(false);
    }
    if (!isClickInsideExpCategoryModalDropdown) {
      setIsExpCategoryModalDropdownOpen(false);
    }
    if (!isClickInsideExpCurrencyFilterDropdown) {
      setIsExpCurrencyFilterDropdownOpen(false);
    }
    if (!isClickInsideExpCurrencyFilterModalDropdown) {
      setIsExpCurrencyFilterModalDropdownOpen(false);
    }
    if (!isClickInsideShowingDropdown) {
      setShowingDropdownOpen(false);
    }
    if (!isClickInsideExpCurrencyDropdown) {
      setCurrencyDropdownOpen(false);
    }
    if (!isClickInsideExpenseUserDropdown) {
      setUserDropdownOpen(false);
    }
    if (!isClickInsideExpClientDropdown) {
      setClientDropdownOpen(false);
    }
    if (!isClickInsideExpProjectDropdown) {
      setProjectDropdownOpen(false);
    }
    if (!isClickInsideExpCompanyDropdown) {
      setCompanyDropdownOpen(false);
    }
    if (!isClickInsideExpenseCategoryDropdown) {
      setCategoryDropdownOpen(false);
    }
    if (!isClickInsideCalendarDropdown) {
      setShowCalendar(false);
    }
    if (!isClickInsideModalCalendarDropdown) {
      setShowModalCalendar(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);

    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const queryClient = useQueryClient();

  const user = useSelector(
    (state) => state.auth.user
  )

  const selectInitialTeam = () => {
    if (user && user._id && (user.userType === userTypeConsts.PROJECT_MANAGER || user.userType === userTypeConsts.TEAM_MANAGER)) {
      const projectManagerTeamId = user._id;
      selectTeam([projectManagerTeamId]);
    }
  };

  // Initialize expCurrencyList once (separate useEffect to avoid infinite loop)
  useEffect(() => {
    setExpCurrencyList(Currencies.sourceCurrencies[0].targetCurrencies);
  }, []);

  // Update selected filters when data changes - only update if data actually changed
  useEffect(() => {
    // Helper function to compare arrays by their values
    const arraysEqual = (arr1, arr2) => {
      if (arr1.length !== arr2.length) return false;
      const sorted1 = [...arr1].sort().join(',');
      const sorted2 = [...arr2].sort().join(',');
      return sorted1 === sorted2;
    };

    // Only update teams if the team IDs have actually changed
    if (teams.length > 0) {
      const teamIds = teams.map((team) => team._id);
      const prevTeamIds = prevTeamsRef.current;
      if (!arraysEqual(teamIds, prevTeamIds)) {
        setSelectedTeams(teamIds);
        prevTeamsRef.current = teamIds;
      }
    } else if (prevTeamsRef.current.length > 0) {
      prevTeamsRef.current = [];
    }

    // Only update clients if the client IDs have actually changed
    if (clients.length > 0) {
      const clientIds = clients.map((client) => client._id);
      const prevClientIds = prevClientsRef.current;
      if (!arraysEqual(clientIds, prevClientIds)) {
        setSelectedClients(clientIds);
        prevClientsRef.current = clientIds;
      }
    } else if (prevClientsRef.current.length > 0) {
      prevClientsRef.current = [];
    }

    // Only update projects if the project IDs have actually changed
    if (projects.length > 0) {
      const projectIds = projects.map((project) => project._id);
      const prevProjectIds = prevProjectsRef.current;
      if (!arraysEqual(projectIds, prevProjectIds)) {
        setSelectedProjects(projectIds);
        prevProjectsRef.current = projectIds;
      }
    } else if (prevProjectsRef.current.length > 0) {
      prevProjectsRef.current = [];
    }

    // Only update departments if the department IDs have actually changed
    if (departments.length > 0) {
      const deptIds = departments.map((dept) => dept._id);
      const prevDeptIds = prevDeptsRef.current;
      if (!arraysEqual(deptIds, prevDeptIds)) {
        setSelectedDepts(deptIds);
        prevDeptsRef.current = deptIds;
      }
    } else if (prevDeptsRef.current.length > 0) {
      prevDeptsRef.current = [];
    }

    // Only update categories if the category IDs have actually changed
    if (expenseCategory && expenseCategory.length > 0) {
      const categoryIds = expenseCategory.map((expCat) => expCat._id);
      const prevCategoryIds = prevCategoriesRef.current;
      if (!arraysEqual(categoryIds, prevCategoryIds)) {
        setSelectedExpCategories(categoryIds);
        prevCategoriesRef.current = categoryIds;
      }
    } else if (prevCategoriesRef.current.length > 0) {
      prevCategoriesRef.current = [];
    }

    // Use the source value directly instead of expCurrencyList state to avoid dependency loop
    // Currency list is static, so we only need to set it once
    if (!currencyListInitializedRef.current) {
      const currencyList = Currencies.sourceCurrencies[0]?.targetCurrencies || [];
      if (currencyList.length > 0) {
        const currencyCodes = currencyList.map((expCurrency) => expCurrency.currencyCode);
        setSelectedExpCurrenciesFilter(currencyCodes);
        currencyListInitializedRef.current = true;
      }
    }

    // Only update status filter if the status values have actually changed
    if (expenseStatusList.length > 0) {
      const statusValues = expenseStatusList.map((expStatus) => expStatus.value);
      const prevStatusValues = prevStatusListRef.current;
      if (!arraysEqual(statusValues, prevStatusValues)) {
        setSelectedExpStatusFilter(statusValues);
        prevStatusListRef.current = statusValues;
      }
    } else if (prevStatusListRef.current.length > 0) {
      prevStatusListRef.current = [];
    }
  }, [teams, clients, projects, departments, expenseCategory, expenseStatusList]);

  const selectTeam = async (team) => {
    await dispatch(setExpTeam(team));
  }
  const selectClient = async (client) => {
    await dispatch(setExpClient(client));
  }
  const selectProject = async (project) => {
    await dispatch(setExpProject(project));
  }
  const selectDepartment = async (department) => {
    await dispatch(setExpDepartment(department));
  }

  const selectExpCategory = async (selExpCategory) => {
    await dispatch(setFilterExpCategory(selExpCategory));
  }

  const selectExpCurrencyFilter = async (selExpCurrency) => {
    await dispatch(setFilterExpCurrency(selExpCurrency));
  }

  const selectExpStatusFilter = async (selExpStatus) => {
    await dispatch(setFilterExpStatus(selExpStatus));
  }

  const selectDate = (date) => {
    if (date) {
      setDates(new Date(date));
    } else {
      setDates(null);
    }
  }

  const handleSelect = (ranges) => {
    setDateRange(ranges);
    if (ranges === null) {
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setDateRange(null);
    }
  };

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const toggleFilterModal = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(!showFilterModal);
  };

  const clearFilters = () => {
    setSelectedTeams(teams.map((team) => team._id));
    setSelectedClients(clients.map((client) => client._id));
    setSelectedProjects(projects.map((project) => project._id));
    setSelectedDepts(departments.map((dept) => dept._id));
    setSelectedExpCategories(expenseCategory.map((expCat) => expCat._id));
    setSelectedExpCurrenciesFilter(expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    setDateRange([startOfYear, endOfToday]);
    setShowFilterModal(false);
  };

  const checkAndShowConfirmationModal = () => {
    const isTeamsModified = !isEqual(selectedTeams, teams.map((team) => team._id));
    const isClientsModified = !isEqual(selectedClients, clients.map((client) => client._id));
    const isProjectsModified = !isEqual(selectedProjects, projects.map((project) => project._id));
    const isDeptsModified = !isEqual(selectedDepts, departments.map((dept) => dept._id));
    const isExpCategoriesModified = !isEqual(selectedExpCategories, expenseCategory.map((expCat) => expCat._id));
    const isExpCurrenciesFilterModified = !isEqual(selectedExpCurrenciesFilter, expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    const isDateRangeModified = !isEqual(dateRange, [startOfYear, endOfToday]);

    if (
      isTeamsModified ||
      isClientsModified ||
      isProjectsModified ||
      isDeptsModified ||
      isExpCategoriesModified ||
      isExpCurrenciesFilterModified ||
      isDateRangeModified
    ) {
      setShowConfirmationModal(true);
    } else {
      setShowFilterModal(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const handleApplyConfirm = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const disableInput = (event) => {
    event.preventDefault();
  };

  const totalResults = expenseTotalCount;

  useEffect(() => {
    setCurrentPage(1);
  }, [expenseData.expTeam, expenseData.expClient, expenseData.expDepartment, expenseData.filterExpCategory, expenseData.filterExpCurrency, expenseData.filterExpStatus, dateRange, allCurrency, selectedCurrency, perPage]);

  const handleOpenCreateModal = () => {
    openCreateModal();
  };

  const handleCloseCreateModal = () => {
    refetchExpenseId();
    resetExpenseForm();
    closeCreateModal();
  };

  const handleDateChange = (date) => {
    setExpenseDate(date);
    setDateValid(false);
  };

  const disabledDate = date => {
    return date > new Date();
  };

  const handleToggleExpCurrencyDropdown = () => {
    setCurrencySearchTerm('');
    setCurrencyDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleExpCurrencySearchInputChange = (e) => {
    setCurrencySearchTerm(e.target.value);
  };

  const filteredExpCurrencies = useMemo(() =>
    expCurrencyList.filter((expCurrency) => {
      const expCurrencyName = expCurrency.currencyCode
        && `${expCurrency.currencyCode} (${expCurrency.currencyName})`;
      return expCurrencyName?.toLowerCase().includes(expCurrencySearchTerm?.toLowerCase());
    }),
  [expCurrencyList, expCurrencySearchTerm]);

  const handleToggleExpenseUserDropdown = () => {
    setUserSearchTerm('');
    setUserDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleSelectExpenseUser = (selectedExpenseUser) => {
    setUser(selectedExpenseUser);
    setUserSearchTerm('');
    setUserDropdownOpen(false);
  };

  const handleExpenseUserSearchInputChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  const filteredUsers = useMemo(() =>
    activeTeams.filter((user) => {
      const fullName = user.first_name
        ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
        : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
      return fullName?.toLowerCase().includes(userSearchTerm?.toLowerCase());
    }),
  [activeTeams, userSearchTerm]);

  const handleToggleExpClientDropdown = () => {
    setClientSearchTerm('');
    setClientDropdownOpen(!expClientDropdownOpen);
  };

  const handleExpClientSearchInputChange = (e) => {
    setClientSearchTerm(e.target.value);
  };

  const filteredClients = useMemo(() =>
    (clients || [])
      .filter((expClient) =>
        expClient.client_name?.toLowerCase().includes(expClientSearchTerm?.toLowerCase() ?? '')
      )
      .sort((a, b) =>
        a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
      ),
  [clients, expClientSearchTerm]);

  const handleToggleExpProjectDropdown = () => {
    setProjectSearchTerm('');
    setProjectDropdownOpen(!expProjectDropdownOpen);
  };

  const handleExpProjectSearchInputChange = (e) => {
    setProjectSearchTerm(e.target.value);
  };

  const filteredProjects = useMemo(() =>
    (projects || [])
      .filter((expProject) =>
        expProject.client_name?._id === expenseClient &&
        expProject?.project_name?.toLowerCase().includes(expProjectSearchTerm?.toLowerCase() ?? '')
      )
      .sort((a, b) =>
        a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase())
      ),
  [projects, expenseClient, expProjectSearchTerm]);

  const handleToggleExpCompanyDropdown = () => {
    setCompanySearchTerm('');
    setCompanyDropdownOpen(!expCompanyDropdownOpen);
  };

  const handleExpCompanySearchInputChange = (e) => {
    setCompanySearchTerm(e.target.value);
  };

  const filteredCompany = useMemo(() =>
    (wXCompany || [])
      .filter((expCompany) =>
        expCompany.wx_company?.toLowerCase().includes(expCompanySearchTerm?.toLowerCase() ?? '')
      )
      .sort((a, b) =>
        a.wx_company?.toLowerCase().localeCompare(b.wx_company?.toLowerCase())
      ),
  [wXCompany, expCompanySearchTerm]);


  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv", "jpeg", "jpg", "png", "gif"];

  const handleExpFileAttchFileUpload = (event) => {
    try {
      const selectedFiles = event.target.files;

      if (selectedFiles.length > 0) {
        if (selectedFiles.length + formState.fileAttachment.length > 10) {
          showErrorToast(
            new Error("Maximum file count exceeded"),
            "file upload",
            {
              code: EXPENSE_ERROR_CODES.FILE_COUNT_EXCEEDED,
              autoClose: 3500,
            }
          );
          return;
        }

        const newFiles = Array.from(selectedFiles);
        const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

        // Validate file extensions and sizes
        const validFiles = newFiles.filter((file) => {
          const fileExtension = file.name.split('.').pop()?.toLowerCase();

          // Check file extension
          if (!allowedExtensions.includes(fileExtension)) {
            showErrorToast(
              new Error(`Invalid file format for ${file.name}`),
              "file upload",
              {
                code: EXPENSE_ERROR_CODES.INVALID_FILE,
                autoClose: 3500,
              }
            );
            return false;
          }

          // Check file size
          if (file.size > MAX_FILE_SIZE) {
            showErrorToast(
              new Error(`File ${file.name} exceeds maximum size limit`),
              "file upload",
              {
                code: EXPENSE_ERROR_CODES.FILE_SIZE_EXCEEDED,
                autoClose: 3500,
              }
            );
            return false;
          }

          return true;
        });

        // Update the state with the valid files
        setFileAttachment((prevFiles) => [...prevFiles, ...validFiles]);

        // Clear the file input for multiple selections
        expFileAttchRef.current.value = '';
      }
    } catch (error) {
      handleError(error, "file upload", {
        code: EXPENSE_ERROR_CODES.INVALID_FILE,
      });
    }
  };

  const removeFile = (index) => {
    // Remove the file at the specified index
    setFileAttachment((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };
  const exportToExcel = withErrorHandling(async () => {
    if (expenseDatas.length === 0) {
      showErrorToast(
        new Error("No data available to export"),
        "export to Excel",
        {
          code: EXPENSE_ERROR_CODES.EXPENSE_EXPORT_FAILED,
          autoClose: 2000,
        }
      );
      return;
    }

    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const baseUrl = `${window.location.protocol}//${window.location.host}`;

      const modifiedLog = expenseDatas.map((item, index) => ({
        "Sl No": index + 1,
        "Expense ID": item.exp_id,
        "User": item.exp_user
          ? item.exp_user.first_name
            ? `${item.exp_user.first_name} ${item.exp_user.middle_name ? item.exp_user.middle_name : ''} ${item.exp_user.last_name ? item.exp_user.last_name : ''}`
            : item.exp_user.company_first_name
              ? `${item.exp_user.company_first_name} ${item.exp_user.company_last_name ? item.exp_user.company_last_name : ''}`
              : item.exp_user.company_name
          : '',
        "Date": moment(item.exp_date)
          .tz(global.config.getTimeZone())
          .format("DD/MM/YYYY"),
        "Category": item.exp_category
          ? item.exp_category.exp_category_name
          : '',
        "Amount": item.exp_amount.toLocaleString("en-US", {
          style: "currency",
          currency: item.exp_currency,
        }),
        "Billable": item.exp_is_billable === true ? "Yes" : "No",
        "Client": item.exp_client
          ? item.exp_client.client_name || item.exp_client.legal_entity_name
          : '',
        "Project": item.exp_project
          ? item.exp_project.project_name
          : '',
        "Company": item.exp_company
          ? item.exp_company.wx_company || item.exp_company.legal_entity_company_name
          : '',
        "Sub Total": item.exp_sub_total ? item.exp_sub_total.toFixed(2) : "0.00",
        "Tax": item.exp_tax ? item.exp_tax.toFixed(2) : "0.00",
        "Net Amount": item.exp_amount.toLocaleString("en-US", {
          style: "currency",
          currency: item.exp_currency,
        }),
        "PDF URL": item.exp_file_attch && item.exp_file_attch.length > 0
          ? item.exp_file_attch
            .map(file => `${baseUrl}/uploads/expense/document/${file}`)
            .join(" ,\n")
          : '',
        "Notes": item.exp_note || '',
        "Created At": moment(item.created_at).tz(global.config.getTimeZone()).format("DD/MM/YYYY, hh:mm:ss A"),
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 25 },
        { wpx: 75 },
        { wpx: 175 },
        { wpx: 110 },
        { wpx: 120 },
        { wpx: 110 },
        { wpx: 80 },
        { wpx: 120 },
        { wpx: 80 },
        { wpx: 80 },
        { wpx: 500 },
        { wpx: 180 },
        { wpx: 150 },
      ];
      worksheet["!cols"] = colWidths;
      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center !important";
        style.alignment.vertical = "center !important";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }
      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }
      global.config.activityLog(
        window.location.href,
        "Expense",
        "Expense Data exported to Excel"
      );
      const fileName = `Expenses_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      handleError(error, "export to Excel", {
        code: EXPENSE_ERROR_CODES.EXPENSE_EXPORT_FAILED,
      });
      throw error; // Re-throw for withErrorHandling wrapper
    }
  }, "export to Excel", {
    code: EXPENSE_ERROR_CODES.EXPENSE_EXPORT_FAILED,
    showToast: true,
  });

  const handleExpenseCategory = (event) => {
    navigate("../expense-category");
  };

  const calculateAmount = (expSubTotal, expTax) => {
    const subTotalAmount = expSubTotal ? parseFloat(expSubTotal) : 0;
    const taxPercentage = expTax ? parseFloat(expTax) : 0;

    if (!isNaN(subTotalAmount) && !isNaN(taxPercentage)) {
      const taxAmount = (subTotalAmount * taxPercentage) / 100;
      return subTotalAmount + taxAmount;
    } else {
      return '';
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setCategoryValid(false);
    setCurrencyValid(false);
    setDateValid(false);
    if (
      expenseId === "" ||
      expDescription === "" ||
      expenseDate === null ||
      expCategory === "" ||
      expCurrency === "" ||
      expSubTotal === "" ||
      expTax === "" ||
      expenseUser === "" ||
      (expIsBillable && expenseClient === "" ? true : false) ||
      (!expIsBillable && expenseCompany === "" ? true : false)
    ) {
      if (expenseDate === null) {
        setDateValid(true);
        dateRef && dateRef.current && dateRef.current.focus();
        toast.error("Expense date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expDescription === "") {
        setDescriptionValid(true);
        descriptionRef && descriptionRef.current.focus();
        toast.error("Expense description cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expCategory === "") {
        setCategoryValid(true);
        categoryRef && categoryRef.current.focus();
        toast.error("Expense category cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expCurrency === "") {
        setCurrencyValid(true);
        currencyRef && currencyRef.current.focus();
        toast.error("Expense currency cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expSubTotal === "") {
        setSubTotalValid(true);
        subTotalRef && subTotalRef.current.focus();
        toast.error("Expense sub total cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expTax === "") {
        setTaxValid(true);
        taxRef && taxRef.current.focus();
        toast.error("Expense Tax cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expenseUser === "") {
        setUserValid(true);
        userRef && userRef.current.focus();
        toast.error("User has to be seleted!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expIsBillable && expenseClient === "") {
        setClientValid(true);
        clientRef && clientRef.current.focus();
        toast.error("Client has to be seleted!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (!expIsBillable && expenseCompany === "") {
        setCompanyValid(true);
        companyRef && companyRef.current.focus();
        toast.error("Company has to be seleted!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    const requestData = {
      exp_id: expenseId,
      exp_description: expDescription,
      exp_date: expenseDate,
      exp_category: expCategory,
      exp_currency: expCurrency,
      exp_sub_total: expSubTotal,
      exp_tax: expTax,
      exp_amount: expAmount,
      exp_is_billable: expIsBillable,
      exp_user: expenseUser,
      exp_clientValue: expIsBillable ? expenseClient : null,
      exp_projectValue: (expIsBillable && expenseClient) ? expenseProject : null,
      exp_CompanyValue: !expIsBillable ? expenseCompany : null,
      exp_note: expNote,
    };

    const formData = new FormData();
    for (let i = 0; i < formState.fileAttachment.length; i++) {
      formData.append("exp_file_attch", expFileAttchFiles[i]);
    }
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }
    try {
      setIsSubmitLoading(true);
      const response = await axios.post("/api/expense/create", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success("Expense data created successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(setNotification(Date.now()));
        handleCloseCreateModal();
        global.config.activityLog(window.location.href, 'Expense', `Expense, (${expenseId}) data created Successfully`);
      }
    } catch (error) {
      handleApiError(error, "expense creation", {
        onRetry: () => handleSubmit(event),
        showToast: true,
      });

      // Handle deleted user case
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        showErrorToast(error, "user authentication", {
          autoClose: 1500,
        });
        navigate("/");
        return;
      }
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const expenseSubmit = async () => {
    var autoData = [];
    if (expenseDate === null) {
      setDateValid(true);
      expenseDateRef && expenseDateRef.current && expenseDateRef.current.focus();
      toast.error("Expense date cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else if (expCategory === "") {
      setCategoryValid(true);
      categoryRef && categoryRef.current.focus();
      toast.error("Expense category cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else if (expCurrency === "") {
      setCurrencyValid(true);
      currencyRef && currencyRef.current.focus();
      toast.error("Expense currency cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else {
      // Convert Date object to ISO string for Redux state (must be serializable)
      const serializedDate = expenseDate ? expenseDate.toISOString() : null;
      autoData.push(serializedDate);
      autoData.push(expCategory);
      autoData.push(expCurrency);
      await dispatch(setExpenseData(autoData));
      navigate("/user/expense/create");
    }
  };

  const onDateChange = (ranges) => {
    try {
      if (!ranges || !ranges.startDate || !ranges.endDate) {
        // fallback to current month if ranges is null or invalid
        const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        setDateRange([firstDayOfMonth, new Date()]);
      } else {
        const start = new Date(ranges.startDate);
        const end = new Date(ranges.endDate);

        // Validate parsed dates
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
          throw new Error("Invalid date range provided.");
        }

        const startOfDayUTC = moment(start).startOf("day").toDate();
        const endOfDayUTC = moment(end).endOf("day").toDate();
        setDateRange([startOfDayUTC, endOfDayUTC]);
      }
    } catch (error) {
      console.error("Error in onDateChange:", error);

      // Fallback to current month
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setDateRange([firstDayOfMonth, new Date()]);
    } finally {
      setShowCalendar(false);
      setShowModalCalendar(false);
    }
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const cancelCalendar = () => {
    setShowCalendar(false);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      border: '0.2px solid rgba(106, 121, 136, 0.7)',
      borderRadius: '10px',
      padding: '8px 16px',
      fontSize: '17px',
      width: '251px',
      color: '#78828D',
      height: '43px',
      padding: '0px',
      cursor: 'pointer',
      textAlign: 'left',
      fontWeight: 300,
      lineHeight: '21px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 16px',
      color: state.isSelected ? 'white' : '#78828D', // Change color for selected item
      backgroundColor: state.isSelected ? '#D1D8FF' : 'transparent', // Change background color for selected item
      fontWeight: 300,
      fontSize: '17px',
      lineHeight: '38px',
      textAlign: 'left',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0px 21px 0px 0px',
      color: state.isFocused ? '#405BFF' : '#405BFF',
    }),
    // Add more custom styles as needed
  };
  const [selDashboardCurrency, setSelDashboardCurrency] = useState("");

  const handleCurrencyChange = async (option) => {

    setSelectedCurrency(option.value);
    setSelDashboardCurrency(option.value);
    const forex = await getForex(option.value);
    setSelectedForex(forex);
    await dispatch(setForex(forex));
    await dispatch(setDashboardCurrencyRx(option.value));
    // Do something with the selected currency value, such as dispatching an action
  };

  const formatOptionLabel = ({ value, label }) => {
    const currencySymbol = label.substring(0, 1); // Extract the currency symbol
    const currencyText = label.substring(1); // Extract the remaining currency text
    return (
      <div className="currency-option">
        <span className="currency-symbol">{new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')}</span>
        <span className="dropdown-text">{label}</span>
      </div>
    );
  };



  const [selectedForex, setSelectedForex] = useState([]);
  const getForex = withErrorHandling(async (currency) => {
    try {
      const response = await withRetry(
        () => axios.post('/api/forex/get', { base_currency: "USD" }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        {
          maxRetries: 3,
          retryDelay: 1000,
        }
      );

      if (response.status === 200) {
        return response.data ? response.data.json : null;
      } else {
        throw new Error(`Request failed with status code: ${response.status}`);
      }
    } catch (error) {
      handleApiError(error, "fetch forex data", {
        onRetry: () => getForex(currency),
        showToast: false, // Don't show toast for background operations
      });
      return null;
    }
  }, "fetch forex data", {
    showToast: false,
    rethrow: false,
  });
  const { data: dashboardCurrency = [], isLoading: isLoadingFetchCurrency } = useFetchDashboardCurrency(user.token);

  // Use refs to track previous values and prevent infinite loops
  const hasFetchedForexRef = useRef(false);
  const previousDashboardCurrencySumRef = useRef(null);
  const previousDashboradCurrencyRef = useRef(null);

  // Separate effect for forex - only fetch once on mount
  useEffect(() => {
    if (!hasFetchedForexRef.current) {
      const ForexUpdate = async () => {
        const forex = await getForex('USD');
        setSelectedForex(forex);
        await dispatch(setForex(forex));
      }
      ForexUpdate();
      hasFetchedForexRef.current = true;
    }
  }, [dispatch]);

  // Effect for currency-related updates - only update if values actually changed
  useEffect(() => {
    // Only update selectedCurrency if dashboradCurrency actually changed
    if (previousDashboradCurrencyRef.current !== dashboradCurrency) {
      setSelectedCurrency(dashboradCurrency);
      previousDashboradCurrencyRef.current = dashboradCurrency;
    }

    // Only dispatch if dashboardCurrencySum actually changed
    if (previousDashboardCurrencySumRef.current !== dashboardCurrencySum) {
      setAllCurrency(dashboardCurrencySum);
      // Only dispatch if the value is different from what's already in Redux
      // Avoid dispatching the same value repeatedly
      const changeSumCur = async () => {
        await dispatch(setDashboardCurrencySum(dashboardCurrencySum));
      }
      changeSumCur();
      previousDashboardCurrencySumRef.current = dashboardCurrencySum;
    }
  }, [dashboardCurrencySum, dashboradCurrency, dispatch]);

  useEffect(() => {
    dispatch(setDashboardCurrencyRx(global.config.appCurrency()));
  }, []);

  const sumAllCurrencies = async (val) => {
    setAllCurrency(val);
    setSelectedCurrency(global.config.appCurrency());
    await dispatch(setDashboardCurrencyRx(global.config.appCurrency()));
    await dispatch(setDashboardCurrencySum(val));
  }

  

  const options = useMemo(() => {
    return expenseCurrencies
      .filter((currency) => getCurrencyByCode.code(currency) != null)
      .map((currency) => ({
        value: currency,
        label: `${getCurrencyByCode.code(currency).currency}`,
      }));
  }, [expenseCurrencies]);

  const toggleModalCalendar = () => {
    setShowModalCalendar(!showModalCalendar);
  };

  const cancelModalCalendar = () => {
    setShowModalCalendar(false);
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    setTimeout(() => {
      e.target.focus()
    }, 0)
  }
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expStatusFilterDropdownRef.current &&
        !expStatusFilterDropdownRef.current.contains(event.target)
      ) {
        setIsExpStatusFilterDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate =
        selectedExpStatusFilter.length > 0 && selectedExpStatusFilter.length < expenseStatusList.length;
    }
  }, [selectedExpStatusFilter]);

  return (
    <>
      <motion.div
        ref={componentRef}
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        transition={{ duration: 0.5 }}
      >
        <div className="overview-outer-time">
          <div className="overview-top">
            {/* Sum of all currencies module */}
            <div className="curency-dropdown curency-dropdown-expense manage-expense-outer">
              <div className="curency-dropdown-inner">
                <div className="currency-title"> {global.config.locate(appSettings && appSettings.language, 'Currency')}</div>
                {(selectedExpCurrenciesFilter && selectedExpCurrenciesFilter.length > 0) ?
                  allCurrency === true ?
                    (
                      <Select
                        key={selectedCurrency}
                        defaultValue={{ value: selectedCurrency || "USD", label: getCurrencyByCode.code(selectedCurrency || "USD")?.currency ?? (selectedCurrency || "USD") }}
                        options={options}
                        styles={customStyles}
                        onChange={handleCurrencyChange}
                        formatOptionLabel={dashboradCurrency && formatOptionLabel}
                      />
                    ) : (
                      <Select
                        key={selectedCurrency}
                        defaultValue={{ value: selectedCurrency, label: getCurrencyByCode.code(selectedCurrency)?.currency ?? selectedCurrency }}
                        options={options}
                        styles={customStyles}
                        onChange={handleCurrencyChange}
                        formatOptionLabel={dashboradCurrency && formatOptionLabel}
                      />
                    ) : isLoadingFetchCurrency === true ? (
                      <div
                        style={{
                          width: "251px",
                          height: "43px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "10px",
                          border: "0.2px solid rgba(106, 121, 136, 0.7)",
                          animation: "pulse 1.5s ease-in-out infinite",
                          display: "flex",
                          alignItems: "center",
                          padding: "0px 16px",
                        }}
                      />
                    ) :
                    global.config.locate(appSettings && appSettings.language, 'No expenses are available for the selected currency')
                }

                {(selectedExpCurrenciesFilter && selectedExpCurrenciesFilter.length > 0) &&
                  <p>{global.config.locate(appSettings && appSettings.language, 'Sum all Currencies')}<input type="checkbox" checked={allCurrency} name="allCurrency" value={allCurrency} onChange={async (e) => {
                    sumAllCurrencies(!allCurrency); localStorage.setItem("allCur", !allCurrency);
                    const forex = await getForex(appSettings && appSettings.currency);
                    setSelectedForex(forex);
                    await dispatch(setForex(forex));
                    if (!allCurrency === true) {
                      await setDashboardCurrencyRx(global.config.appCurrency());
                      setSelectedCurrency(global.config.appCurrency());
                    }
                  }} />
                  </p>
                }
              </div>
              <div className="manage">
                <a onClick={handleExpenseCategory}>
                  <span className="icon-invoice">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_1143_332)">
                        <path d="M19.0704 7.87245C18.7124 7.87245 18.3983 7.6613 18.2626 7.33065L18.2304 7.25449C18.0947 6.92941 18.1709 6.55604 18.4255 6.30093C19.1789 5.54799 19.1733 4.32322 18.4255 3.57585L17.4281 2.57895C16.702 1.85263 15.4444 1.84768 14.7121 2.5678L14.7009 2.57895C14.4463 2.82786 14.0721 2.90402 13.7525 2.76842L13.6763 2.73622C13.3454 2.60619 13.1342 2.28607 13.1342 1.92879C13.1342 0.866873 12.2668 0 11.2044 0H9.78936C8.72688 0 7.85954 0.866873 7.85954 1.92879C7.85954 2.28669 7.64828 2.60619 7.32303 2.73622L7.25241 2.76842C6.92716 2.90402 6.55359 2.83344 6.29834 2.57895C5.545 1.83158 4.32516 1.83158 3.57182 2.57895L2.57438 3.57585C1.82104 4.32879 1.82104 5.54799 2.57438 6.3065C2.82901 6.56099 2.89963 6.92941 2.76396 7.26006L2.7367 7.33065C2.6066 7.6613 2.28631 7.87245 1.92884 7.87245C0.866357 7.87245 -0.000976562 8.73932 -0.000976562 9.80124V11.2099C-0.000976562 12.2774 0.866357 13.1387 1.91831 13.1387C2.27639 13.1387 2.59049 13.3498 2.72617 13.6749L2.75838 13.7511C2.89406 14.0762 2.81786 14.4495 2.56323 14.7046C1.81485 15.4576 1.81485 16.6824 2.56881 17.4297L3.57182 18.4266C4.32516 19.1746 5.545 19.1746 6.29834 18.4211C6.54739 18.1721 6.92158 18.096 7.24683 18.2316L7.31746 18.2638C7.64828 18.3938 7.85954 18.7139 7.85954 19.0712C7.85954 20.1331 8.72688 21 9.78936 21H11.2044C12.2668 21 13.1342 20.1387 13.1391 19.0656C13.1391 18.7077 13.3504 18.3938 13.6812 18.2582C13.6868 18.2582 13.7518 18.231 13.7518 18.231C14.0771 18.0954 14.4513 18.1715 14.7003 18.4204L14.7115 18.4316C15.4376 19.1523 16.7008 19.1467 17.4275 18.4204L18.4249 17.4235C19.1782 16.6762 19.1782 15.457 18.4249 14.6985C18.1759 14.4495 18.0996 14.0755 18.2353 13.7505L18.2626 13.6799C18.3983 13.3492 18.713 13.1381 19.0704 13.1381C20.1329 13.1381 21.0003 12.2712 21.0003 11.2093V9.80062C21.0003 8.7387 20.1329 7.87183 19.0704 7.87183V7.87245ZM19.965 11.2037C19.965 11.6861 19.5692 12.0817 19.0866 12.0817C18.2948 12.0817 17.596 12.5529 17.3029 13.2793L17.2757 13.3443C16.9721 14.065 17.1351 14.8885 17.6932 15.4464C18.0346 15.7932 18.0346 16.3461 17.6932 16.6873L16.6958 17.6842C16.3538 18.0254 15.7956 18.0254 15.4543 17.6842L15.4431 17.6731C14.8905 17.1257 14.0666 16.9684 13.351 17.2669L13.5517 17.7492L13.286 17.2885C12.5599 17.5814 12.0878 18.2805 12.0878 19.0712C12.0878 19.5536 11.6919 19.9492 11.2093 19.9492H9.79431C9.31171 19.9492 8.91583 19.5591 8.91583 19.0712C8.91583 18.2854 8.44995 17.587 7.72325 17.2941L7.6582 17.2669C7.41968 17.1641 7.16506 17.1152 6.91539 17.1152C6.41667 17.1152 5.92911 17.3158 5.57102 17.6842C5.22904 18.0254 4.67085 18.0254 4.32949 17.6842L3.33206 16.6873C2.99008 16.3461 2.99008 15.7882 3.33764 15.4415C3.89025 14.8892 4.05319 14.065 3.74962 13.3449L3.72236 13.2799C3.42437 12.5591 2.72493 12.0879 1.93875 12.0879C1.45614 12.0879 1.06027 11.6923 1.06027 11.2099V9.80124C1.06027 9.31889 1.45057 8.92322 1.93875 8.92322C2.72493 8.92322 3.42437 8.45201 3.72236 7.7257L3.74962 7.66625C4.05319 6.94551 3.89025 6.12198 3.33206 5.56409C2.9907 5.21734 2.9907 4.6644 3.33206 4.32322L4.32949 3.32632C4.67147 2.98514 5.22966 2.98514 5.57102 3.32632C6.12426 3.88421 6.9476 4.04706 7.6743 3.74365L7.73378 3.72198C8.4549 3.42415 8.92636 2.72508 8.92636 1.93932C8.92636 1.45697 9.32224 1.0613 9.80485 1.0613H11.2198C11.7024 1.0613 12.0983 1.45139 12.0983 1.93932C12.0983 2.72508 12.5642 3.42353 13.2909 3.71641L13.5077 3.23406L13.356 3.73808C14.0771 4.03591 14.8955 3.87864 15.4481 3.33189L15.4592 3.32074C15.8012 2.97957 16.3594 2.97957 16.7008 3.32074L17.6982 4.31765C18.0402 4.65944 18.0402 5.21176 17.6926 5.55851C17.1394 6.11641 16.9771 6.93498 17.2751 7.65511L17.3023 7.72012C17.6003 8.44582 18.2998 8.91765 19.0859 8.91765C19.5685 8.91765 19.9644 9.31331 19.9644 9.79567V11.2043L19.965 11.2037Z" fill="#6A7988" />
                        <path d="M10.4949 5.60248C7.79011 5.60248 5.58398 7.80743 5.58398 10.5108C5.58398 13.2142 7.78453 15.4192 10.4949 15.4192C13.2054 15.4192 15.4065 13.2142 15.4059 10.5108C15.4059 7.80743 13.1998 5.60248 10.4949 5.60248ZM10.4949 14.3635C8.36998 14.3635 6.63532 12.6297 6.63532 10.5059C6.63532 8.38204 8.36441 6.6483 10.4949 6.6483C12.6255 6.6483 14.3546 8.38204 14.3546 10.5059C14.3546 12.6297 12.6199 14.3635 10.4949 14.3635Z" fill="#6A7988" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1143_332">
                          <rect width="21" height="21" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Manage Categories
                </a>
              </div>
            </div>

            {/* Sum of all currencies module */}

            <div className="overview-top-inner">
              <div className="overview-top-left">
                <a className="btn-forpop-initem"
                  onClick={handleOpenCreateModal}
                >
                  <span className="icon-invoice">
                    <img src={PlusIcon} alt="Add new Expense " />
                  </span>
                  New Expense
                </a>

                <Modal
                  className="client-modal sprint-modal sprint-modal-expense"
                  isOpen={isCreateModalOpen}
                  onRequestClose={!isSubmitLoading ? handleCloseCreateModal : undefined}
                  contentLabel="Create  Expense"
                  style={{
                    content: {
                      height: "41%",
                      width: "30%",
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      parent: document.querySelector(".admin-outer.time.tracker"),
                    },
                  }}
                >
                  <div className="modal timeoff-modal">
                    <div className="modal-close-invite outter-modal-main">
                      <a className="" onClick={handleCloseCreateModal} disabled={isSubmitLoading}>
                        <img src={crssrImage} alt="Edit Icon" />{" "}
                      </a>
                    </div>
                    <div className="modal-client-head">
                      <h2 className="">New Expense</h2>
                    </div>
                    <div className="form-field-client-outer profile-details-edit expense-modal-scroll">
                      <div className="form-field-client" >
                        <label htmlFor="projectName" className="form-label">
                          Date
                        </label>
                        <div className={`date-picker-outer date-picker-outer-all ${expenseDateIsValid ? 'input-validation-error' : ''}`}>
                          <div className="custoom-icon-calender custoom-icon-calender-all">
                            <DatePicker
                              oneTap
                              format="dd/MM/yyyy"
                              ranges={ranges}
                              value={expenseDate}
                              onChange={handleDateChange}
                              placement="auto"
                              className="invoice-filter-top-date"
                              isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === 'Monday'}
                              disabledDate={disabledDate}
                              caretAs={CalendarIcon}
                            />
                          </div>
                        </div>

                      </div>
                      <div className="form-field-client">
                        <label htmlFor="category" className="form-label">
                          Category
                        </label>

                        {isLoadingExpCategory == true ? (
                          <div
                            className="custom-dropdown-user-new custom-dropdown-select"
                            style={{
                              height: "43px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "7px",
                              animation: "pulse 1.5s ease-in-out infinite",
                              display: "flex",
                              alignItems: "center",
                              padding: "8px 12px",
                            }}
                          />
                        ) : (
                          <div
                            ref={expenseCategoryDropdownRef}
                            className={`cursor ${expenseCategoryDropdownOpen ? 'open' : ''}`}
                          >
                            <span
                              id="user-select"
                              onClick={() => setCategoryDropdownOpen(!expenseCategoryDropdownOpen)}
                              className={`custom-dropdown-user-new custom-dropdown-select ${expenseCategoryIsValid ? 'input-validation-error' : ''}`}
                              ref={categoryRef}
                            >
                              {expCategory ? expenseCategory.find((exp) => exp._id === expCategory)?.exp_category_name : 'Select'}
                            </span>
                            {expenseCategoryDropdownOpen && (
                              <div className="custom-dropdown-new">
                                {expenseCategory && expenseCategory.length > 0 ? (
                                  <ul className="leave-type-list">
                                    {expenseCategory &&
                                      expenseCategory
                                        .slice()
                                        .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                        .map((exp) => (
                                          <li
                                            key={exp._id}
                                            className={expCategory === exp._id ? 'selected-item' : ''}
                                            onClick={() => {
                                              setCategory(exp._id);
                                              setCategoryDropdownOpen(false);
                                              setCategoryValid(false);
                                            }}
                                          >
                                            {exp.exp_category_name}
                                          </li>
                                        ))}
                                  </ul>
                                ) : (
                                  <div className="text-gray-500 text-sm italic">No categories available</div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="form-field-client">
                        <label htmlFor="client" className="form-label">
                          Currency
                        </label>
                        <div ref={expCurrencyDropdownRef} className={`cursor ${expCurrencyDropdownOpen ? 'open' : ''}`} >
                          <span
                            id="user-select"
                            onClick={handleToggleExpCurrencyDropdown}
                            className={`custom-dropdown-user-new custom-dropdown-user ${expenseCurrencyIsValid ? 'input-validation-error' : ''}`}
                            ref={currencyRef}
                          >
                            {expCurrency ? expCurrencyList.find((c) => c.currencyCode === expCurrency)?.currencyCode : 'Select Currency'}
                          </span>
                          {expCurrencyDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <input
                                type="text"
                                className="search-bar"
                                placeholder="Search..."
                                value={expCurrencySearchTerm}
                                onChange={handleExpCurrencySearchInputChange}
                              />
                              <ul className="currency-list">
                                {filteredExpCurrencies.length > 0 &&
                                  filteredExpCurrencies.map((c) => (
                                    <li
                                      key={c.currencyCode}
                                      className={expCurrency === c.currencyCode ? 'selected-item' : ''}
                                      onClick={() => {
                                        setCurrency(c.currencyCode);
                                        setCurrencyDropdownOpen(false);
                                        setCurrencyValid(false);
                                      }}
                                    >
                                      {`${c.currencyCode} (${c.currencyName})`}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          )}
                        </div>

                      </div>

                      <button type="submit" className="submit-client" disabled={isSubmitLoading} onClick={expenseSubmit}>
                        {isSubmitLoading ? (
                          <div
                            style={{
                              width: "120px",
                              height: "18px",
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                        ) : 'Create Expense'}
                      </button>
                    </div>
                  </div>
                </Modal>

                <a onClick={exportToExcel}>
                  <span className="icon-export">
                    <img src={DownloadImage} alt="Export" />
                  </span>
                  Export Data
                </a>
              </div>

              <div className="overview-top-right expense-overview">
                <div className="showing-count">
                  <div className="filter-inner showing-result">
                    <label>Showing</label>
                    <div ref={showingDropdownRef} className="select-modal-mainM custom-dropdown-user-new-outer">
                      <div className="selected-option custom-dropdown-user-new" onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}>
                        {totalResults < 10 ? totalResults.toString() : perPage.toString()}
                      </div>
                      {showingDropdownOpen && (
                        <div className="custom-dropdown-new">
                          <ul className="showing-options-list">
                            {totalResults >= 10 && <li className={perPage === 10 ? 'selected-item' : ''} onClick={() => { setPerPages(10); setShowingDropdownOpen(false); }}>10</li>}
                            {totalResults >= 20 && <li className={perPage === 20 ? 'selected-item' : ''} onClick={() => { setPerPages(20); setShowingDropdownOpen(false); }}>20</li>}
                            {totalResults >= 30 && <li className={perPage === 30 ? 'selected-item' : ''} onClick={() => { setPerPages(30); setShowingDropdownOpen(false); }}>30</li>}
                            {totalResults >= 40 && <li className={perPage === 40 ? 'selected-item' : ''} onClick={() => { setPerPages(40); setShowingDropdownOpen(false); }}>40</li>}
                            {totalResults >= 10 && <li className={totalResults >= 10 && perPage === totalResults ? 'selected-item' : ''} onClick={() => { setPerPages(totalResults); setShowingDropdownOpen(false); }}>ALL</li>}
                            {/* Add more conditions as needed */}
                            {totalResults < 10 ? (
                              <li className={totalResults < 10 ? 'selected-item' : ''} onClick={() => { setPerPages(totalResults); setShowingDropdownOpen(false); }}>{totalResults}</li>
                            ) : null}
                          </ul>
                        </div>
                      )}
                    </div>
                    <label>of {expenseTotalCount} Results</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="overview-inner-section">
            <ExpenseFilters
              dateRange={dateRange}
              showFilterModal={showFilterModal}
              showCalendar={showCalendar}
              showModalCalendar={showModalCalendar}
              showConfirmationModal={showConfirmationModal}
              selectedTeams={selectedTeams}
              selectedClients={selectedClients}
              selectedProjects={selectedProjects}
              selectedDepts={selectedDepts}
              selectedExpCategories={selectedExpCategories}
              selectedExpCurrenciesFilter={selectedExpCurrenciesFilter}
              selectedExpStatusFilter={selectedExpStatusFilter}
              isTeamDropdownOpen={isTeamDropdownOpen}
              isTeamModalDropdownOpen={isTeamModalDropdownOpen}
              isClientDropdownOpen={isClientDropdownOpen}
              isClientModalDropdownOpen={isClientModalDropdownOpen}
              isProjectDropdownOpen={isProjectDropdownOpen}
              isProjectModalDropdownOpen={isProjectModalDropdownOpen}
              isDeptDropdownOpen={isDeptDropdownOpen}
              isDeptModalDropdownOpen={isDeptModalDropdownOpen}
              isExpCategoryDropdownOpen={isExpCategoryDropdownOpen}
              isExpCategoryModalDropdownOpen={isExpCategoryModalDropdownOpen}
              isExpCurrencyFilterDropdownOpen={isExpCurrencyFilterDropdownOpen}
              isExpCurrencyFilterModalDropdownOpen={isExpCurrencyFilterModalDropdownOpen}
              isExpStatusFilterDropdownOpen={isExpStatusFilterDropdownOpen}
              selectAllTeam={selectAllTeam}
              selectAllClient={selectAllClient}
              selectAllProject={selectAllProject}
              selectAllDept={selectAllDept}
              selectAllExpCategory={selectAllExpCategory}
              selectAllExpCurrencyFilter={selectAllExpCurrencyFilter}
              selectAllExpStatusFilter={selectAllExpStatusFilter}
              userDropdownSearchTerm={userDropdownSearchTerm}
              clientDropdownSearchTerm={clientDropdownSearchTerm}
              expProjectSearchTerm={projectFilterSearchTerm}
              departmentDropdownSearchTerm={departmentDropdownSearchTerm}
              categoryDropdownSearchTerm={categoryDropdownSearchTerm}
              expCurrencyDropdownSearchTerm={expCurrencyDropdownSearchTerm}
              expStatusDropdownSearchTerm={expStatusDropdownSearchTerm}
              teams={teams}
              clients={clients}
              projects={projects}
              departments={departments}
              expenseCategory={expenseCategory}
              expCurrencyList={expCurrencyList}
              user={user}
              onDateChange={onDateChange}
              onToggleFilterModal={toggleFilterModal}
              onToggleCalendar={toggleCalendar}
              onCancelCalendar={cancelCalendar}
              onToggleModalCalendar={toggleModalCalendar}
              onCancelModalCalendar={cancelModalCalendar}
              onClearFilters={clearFilters}
              onApplyFilters={applyFilters}
              onCheckAndShowConfirmationModal={checkAndShowConfirmationModal}
              onCancel={handleCancel}
              onApplyConfirm={handleApplyConfirm}
              onCheckboxTeamChange={handleCheckboxTeamChange}
              onSelectAllTeamChange={handleSelectAllTeamChange}
              onToggleTeamDropdown={toggleTeamDropdown}
              onToggleTeamModalDropdown={toggleTeamModalDropdown}
              onUserDropdownSearchChange={handleUserDropdownSearchChange}
              onCheckboxClientChange={handleCheckboxClientChange}
              onSelectAllClientChange={handleSelectAllClientChange}
              onToggleClientDropdown={toggleClientDropdown}
              onToggleClientModalDropdown={toggleClientModalDropdown}
              onClientDropdownSearchChange={handleClientDropdownSearchChange}
              onCheckboxProjectChange={handleCheckboxProjectChange}
              onSelectAllProjectChange={handleSelectAllProjectChange}
              onToggleProjectDropdown={toggleProjectDropdown}
              onToggleProjectModalDropdown={toggleProjectModalDropdown}
              onProjectSearchChange={(e) => setProjectFilterSearchTerm(e.target.value)}
              onCheckboxDeptChange={handleCheckboxDeptChange}
              onSelectAllDeptChange={handleSelectAllDeptChange}
              onToggleDeptDropdown={toggleDeptDropdown}
              onToggleDeptModalDropdown={toggleDeptModalDropdown}
              onDepartmentDropdownSearchChange={handleDepartmentDropdownSearchChange}
              onCheckboxExpCategoryChange={handleCheckboxExpCategoryChange}
              onSelectAllExpCategoryChange={handleSelectAllExpCategoryChange}
              onToggleExpCategoryDropdown={toggleExpCategoryDropdown}
              onToggleExpCategoryModalDropdown={toggleExpCategoryModalDropdown}
              onCategoryDropdownSearchChange={handleCategoryDropdownSearchChange}
              onCheckboxExpCurrencyFilterChange={handleCheckboxExpCurrencyFilterChange}
              onSelectAllExpCurrencyFilterChange={handleSelectAllExpCurrencyFilterChange}
              onToggleExpCurrencyFilterDropdown={toggleExpCurrencyFilterDropdown}
              onToggleExpCurrencyFilterModalDropdown={toggleExpCurrencyFilterModalDropdown}
              onExpCurrencyDropdownSearchChange={handleExpCurrencyDropdownSearchChange}
              onCheckboxExpStatusFilterChange={handleCheckboxExpStatusFilterChange}
              onSelectAllExpStatusFilterChange={handleSelectAllExpStatusFilterChange}
              onToggleExpStatusFilterDropdown={toggleExpStatusFilterDropdown}
              onExpStatusDropdownSearchChange={handleExpStatusDropdownSearchChange}
              calendarRef={calendarRef}
              calendarModalRef={calendarModalRef}
              calendarModalPortalRef={calendarModalPortalRef}
              teamDropdownRef={teamDropdownRef}
              teamModalDropdownRef={teamModalDropdownRef}
              clientDropdownRef={clientDropdownRef}
              clientModalDropdownRef={clientModalDropdownRef}
              projectDropdownRef={projectDropdownRef}
              projectModalDropdownRef={projectModalDropdownRef}
              deptDropdownRef={deptDropdownRef}
              deptModalDropdownRef={deptModalDropdownRef}
              expCategoryDropdownRef={expCategoryDropdownRef}
              expCategoryModalDropdownRef={expCategoryModalDropdownRef}
              expCurrencyFilterDropdownRef={expCurrencyFilterDropdownRef}
              expCurrencyFilterModalDropdownRef={expCurrencyFilterModalDropdownRef}
              expStatusFilterDropdownRef={expStatusFilterDropdownRef}
              startOfYear={startOfYear}
              endOfToday={endOfToday}
            />
          </div>

          <div className="overview-outer-sec-time tab-inner-time">
            <div className="total-sec-overview">
              <ExpenseOverviewTotal expCategories={selectedExpCategories} expenseData={expenseDatas} totalCount={expenseTotalCount} currencyTotals={currencyTotals} isLoading={expenseLoading} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
            </div>
            <div className="graph-piechart">
              <div className="overview-graph-time">
                <ExpenseOverviewGraph graphDate={dateRange ? dateRange[1] : null} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
              </div>
              <div className="piechart">
                <ExpenseOverviewPieChart expenseData={expenseDatas} isLoading={expenseLoading} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
              </div>
            </div>
            <div className="time-table-section time-table-section-project-client">
              <ExpenseTable expenseData={expenseDatas} perPage={perPage} graphDate={dateRange} user={user} isLoading={expenseLoading} queryClient={queryClient} allCurrency={allCurrency} selectedCurrency={selectedCurrency} currentPage={currentPage} totalCount={expenseTotalCount} currencyTotals={currencyTotals} onPageChange={setCurrentPage} />
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

// Wrap component with ErrorBoundary
const ExpenseOverview = () => {
  return (
    <ExpenseErrorBoundary>
      <ExpenseOverviewContent />
    </ExpenseErrorBoundary>
  );
};

export default ExpenseOverview;